import About from "./components/About";

function App() {
  return (
    <>
      <About />
    </>
  );
}

export default App;
